import { PreferredCopy } from '../types';
import OneLineTextField from '../../../components/raExtend/fields/OneLineTextField';
import { useTranslate } from 'react-admin';
import { Fragment } from 'react';

type Props = {
  preferredCopies: PreferredCopy[];
};

function PreferredCopies({ preferredCopies }: Props) {
  const t = useTranslate();

  return (
    <div>
      {preferredCopies.map(({ lang, offer_titles }) => (
        <Fragment key={lang}>
          {offer_titles.map(title => {
            if (!title || !lang) return null;
            return (
              <OneLineTextField
                key={`${lang}-${title}`}
                label={t(`constant.language.${lang}`)}
                record={{ title }}
                source="title"
              />
            );
          })}
        </Fragment>
      ))}
    </div>
  );
}

export default PreferredCopies;
